import styled from 'styled-components';
import { NEUTRAL_1600 } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledButton = styled.button.withConfig({
  displayName: "SpotlightLauncherStub__StyledButton"
})(["border:1px solid #ccc;border-radius:24px;padding:12px 24px;background-color:white;cursor:pointer;font-size:14px;font-weight:500;color:", ";margin-bottom:32px;transition:background-color 150ms ease;&:hover{background-color:#f5f5f5;}"], NEUTRAL_1600);
const SpotlightLauncherStub = ({
  onClick
}) => /*#__PURE__*/_jsx(StyledButton, {
  onClick: onClick,
  "data-test-id": "spotlight-launcher-stub",
  children: 'Continue conversation'
});
SpotlightLauncherStub.displayName = 'SpotlightLauncherStub';
export default SpotlightLauncherStub;